import { useEffect, useState } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import DisplayModal from "../common/Modal/displayModal";
import { useNavigate } from "react-router-dom";
import {
  deleteSingleAndGroupTeamListingDetails,
  deleteSingleTeamListingDetails,
  getLocationLists,
  getTeamListingDetails,
} from "./action";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../common/Spinner/spinner";
import { teamsSelector } from "./selector";
import ToolTip from "../common/ToolTip/ToolTip";
import Modal from "../common/Modal/modal";
import { toast } from "react-toastify";

const ListTeams = () => {
  const { loadingFlag } = useSelector(teamsSelector);
  const navigate = useNavigate();
  const [showListTeamsPopup, setShowListTeamsPopup] = useState(false);
  const [teamsDetailsLists, setTeamsDetailsLists] = useState([]);
  const [locationDropdownId, setLocationDropdownId] = useState("");
  const [listItems, setListItems] = useState([]);

  // config use to BaseURL
  const config = useConfiguration();
  // Session storage items handling
  const storage = useSessionStorage();
  // get from Login details
  const login = storage.getItem("login");
  // redux dispatch initialize
  const dispatch = useDispatch();

  // Location dropdown initial state
  const [locationLists, setLocationLists] = useState([]);

  const closeListTeamsPopup = () => {
    setShowListTeamsPopup(false);
  };

  const viewOnlyPopup = (items) => {
    setShowListTeamsPopup(true);
    setTeamsDetailsLists(items);
  };

  // Delete Modal popup
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState("");

  const closeDeletePopup = () => {
    setDeleteModal(false);
  };

  const naigateCreateTeamsPageEdit = (team) => {
    navigate("/createteam", {
      state: {
        pageTitle: "Edit Team",
        team,
        saveTitle: "Save",
      },
    });
  };

  // Location Drodown API Call
  useEffect(() => {
    if (config.baseUrl) {
      dispatch(getLocationLists(config.baseUrl, login.employerUniqueId)).then(
        (response) => setLocationLists(response)
      );
    }
  }, [config.baseUrl]);

  // List Teams Details
  useEffect(() => {
    if (config.baseUrl) {
      dispatch(
        getTeamListingDetails(
          config.baseUrl,
          locationDropdownId ? locationDropdownId : 0
        )
      ).then((response) => setListItems(response));
    }
  }, [config.baseUrl, locationDropdownId]);

  // delete Group Canddiate Team members
  const deleteGroupOrSingleCandidate = () => {
    if (
      (config.baseUrl && deleteData?.candidateTeamId) ||
      deleteData?.item?.candidateTeamMemberId
    ) {
      deleteData?.flag !== true
        ? dispatch(
            deleteSingleAndGroupTeamListingDetails(
              `${config.baseUrl}/TeamScheduling/delete-candidates-team?CandidateTeamId=${deleteData?.candidateTeamId}`,
              true
            )
          ).then(() => {
            dispatch(
              getTeamListingDetails(
                config.baseUrl,
                locationDropdownId ? locationDropdownId : 0
              )
            ).then((response) => setListItems(response));
            closeDeletePopup();
            setDeleteData("");
          })
        : dispatch(
            deleteSingleAndGroupTeamListingDetails(
              `${config.baseUrl}/TeamScheduling/delete-team-member?CandidateTeamMemberId=${deleteData?.item?.candidateTeamMemberId}`
            )
          ).then(() => {
            dispatch(
              getTeamListingDetails(
                config.baseUrl,
                locationDropdownId ? locationDropdownId : 0
              )
            ).then((response) => setListItems(response));
            setShowListTeamsPopup(false);
            closeListTeamsPopup();
            closeDeletePopup();
            setDeleteData("");
          });
    }
  };

  return (
    <>
      {loadingFlag > 0 && <Spinner />}
      <Header />
      <Sidebar />
      {showListTeamsPopup && (
        <DisplayModal
          showHide={closeListTeamsPopup}
          label={"Teams Candidates List"}
          size={"xl"}
        >
          <GroupListingPageReadOnly
            teamsDetailsLists={teamsDetailsLists}
            setDeleteModal={setDeleteModal}
            setDeleteData={setDeleteData}
          />
        </DisplayModal>
      )}
      {deleteModal && (
        <Modal
          showHide={closeDeletePopup}
          saveFunction={deleteGroupOrSingleCandidate}
          label={"Delete"}
          size={"md"}
          onlyClose={false}
          buttonName={"Delete"}
        >
          <div className="text-center">{`Are you sure want to delete the ${
            deleteData?.teamName || deleteData?.item?.fullName
          } ${
            deleteData?.teamName
              ? `Team`
              : deleteData?.item?.fullName
              ? `Candidate`
              : ""
          }?`}</div>
        </Modal>
      )}
      <div className="page main-margin">
        <div className="page-main">
          <div className="main-content app-content mt-0 main-background">
            <div className="side-app">
              <div className="main-container container-fluid">
                <div className="page-header">
                  <h1 className="page-title">List Teams</h1>
                </div>

                <div class="card">
                  <div class="card-body">
                    <div class="panel panel-primary">
                      <div className="w-25">
                        {/* Location dropdown */}
                        Location <span className="text-danger">*</span>
                        <select
                          className="form-select"
                          name="locationName"
                          onChange={(e) =>
                            setLocationDropdownId(e.target.value)
                          }
                        >
                          <option value={0}>-- Select --</option>
                          {locationLists.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                {listItems?.candidateTeamListDetails?.length > 0 ? (
                  <div class="card">
                    <div class="card-body">
                      <div class="panel panel-primary">
                        <table className="table">
                          <thead>
                            <tr>
                              <th style={{ textTransform: "none" }}>
                                Team Name
                              </th>
                              <th style={{ textTransform: "none" }}>
                                Departments
                              </th>
                              <th style={{ textTransform: "none" }}>
                                Location
                              </th>
                              <th
                                style={{ textTransform: "none" }}
                                className="text-center"
                              >
                                Team Members Count
                              </th>
                              <th style={{ textTransform: "none" }}>Active</th>
                              <th style={{ textTransform: "none" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listItems?.candidateTeamListDetails?.map &&
                              listItems?.candidateTeamListDetails?.map(
                                (item) => (
                                  <tr key={item.candidateUniqueId}>
                                    <td>{item.teamName}</td>
                                    <td>{item?.departmentName}</td>
                                    <td>{item.locationName}</td>
                                    <td className="text-center">
                                      {item.teamMembersCount}
                                    </td>
                                    <td>{item.isActive ? "Yes" : "No"}</td>

                                    <td>
                                      <div className="d-flex gap-4">
                                        <ToolTip
                                          position={"left"}
                                          value={"View Candidates"}
                                        >
                                          <i
                                            className="fa fa-eye fa-lg mt-1"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              viewOnlyPopup(
                                                item?.candidatesTeamMember
                                              )
                                            }
                                          ></i>
                                        </ToolTip>
                                        <ToolTip
                                          position={"left"}
                                          value={"Edit Teams"}
                                        >
                                          <i
                                            className="fa fa-edit fa-lg mt-1"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              naigateCreateTeamsPageEdit(item)
                                            }
                                          ></i>
                                        </ToolTip>
                                        <ToolTip
                                          position={"left"}
                                          value={"Delete Teams"}
                                        >
                                          <i
                                            onClick={() => {
                                              setDeleteModal(true);
                                              setDeleteData(item);
                                            }}
                                            className="fe fe-trash-2 fa-lg"
                                            style={{ cursor: "pointer" }}
                                          ></i>
                                        </ToolTip>
                                      </div>
                                    </td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div class="card">
                    <div class="card-body">
                      <div class="panel panel-primary">
                        <table className="table">
                          <thead>
                            <tr>
                              <th style={{ textTransform: "none" }}>
                                Team Name
                              </th>
                              <th style={{ textTransform: "none" }}>
                                Departments
                              </th>
                              <th style={{ textTransform: "none" }}>
                                Location
                              </th>
                              <th style={{ textTransform: "none" }}>
                                Team Members Count
                              </th>
                              <th style={{ textTransform: "none" }}>Status</th>
                              <th style={{ textTransform: "none" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody></tbody>
                        </table>
                        <h2 className="text-center">No Teams Found</h2>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListTeams;

// View page Showing a Group Listing details
const GroupListingPageReadOnly = ({
  teamsDetailsLists,
  setDeleteModal,
  setDeleteData,
}) => {
  return (
    <div>
      {teamsDetailsLists?.length > 0 ? (
        <table className="table">
          <thead>
            <tr>
              <th style={{ textTransform: "none" }}>Name</th>
              <th style={{ textTransform: "none" }}>Email</th>
              <th style={{ textTransform: "none" }}>Location Status</th>
              <th style={{ textTransform: "none" }}>Level</th>
              <th style={{ textTransform: "none" }}>Department</th>
              <th style={{ textTransform: "none" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {teamsDetailsLists?.map((item) => (
              <tr key={item.candidateUniqueId}>
                <td>{item.fullName}</td>
                <td>{item.emailAddress}</td>
                <td>{item.statusOFLocation}</td>
                <td>{item.jobLevel}</td>
                <td>{item.departmentName}</td>
                <td>
                  <i
                    onClick={() => {
                      setDeleteData({ item: item, flag: true });
                      setDeleteModal(true);
                    }}
                    className="fe fe-trash-2 fa-lg"
                    style={{ cursor: "pointer" }}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div>
          <table className="table">
            <thead>
              <tr>
                <th style={{ textTransform: "none" }}>Name</th>
                <th style={{ textTransform: "none" }}>Email</th>
                <th style={{ textTransform: "none" }}>Location Status</th>
                <th style={{ textTransform: "none" }}>Level</th>
                <th style={{ textTransform: "none" }}>Department</th>
                <th style={{ textTransform: "none" }}>Action</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
          <h2 className="text-center">No Candidates Found</h2>
        </div>
      )}
    </div>
  );
};
